import { createSelector } from 'reselect';
const getReportTypeList = state => state.reportTypeFilterAdd.list;
const getDynamicReportTypes = createSelector(getReportTypeList, list => list.filter(rt => rt.isDynamic));
export default {
  getDynamicReportTypes
};